import { LocalizationStore } from './localizationStore';
import { ScaleUnitStore } from './scaleUnitStore';
import { ThemingStore } from './themingStore';
import { TimeZonesStore } from './timeZonesStore';

export const localizationStore = new LocalizationStore();
export const scaleUnitStore = new ScaleUnitStore();
export const timeZonesStore = new TimeZonesStore();
export const themingStore = new ThemingStore();
